import axiosInstance from 'api/axiosInstance';
import { stringify } from 'query-string';
import type { Duplicate } from 'types/global.types';
import type { Paging } from 'types/pagination.types';
import { TWO_MINUTES } from 'utils/time';

const getDocumentDuplicates = (
  documentId: string,
): Promise<{ duplicates: Duplicate[]; paging: Paging }> => {
  return axiosInstance
    .get<{ duplicates: Duplicate[]; paging: Paging }>(
      `/v2/repository-documents/duplicates/${documentId}?${stringify({
        perPage: 9999,
        page: 1,
      })}`,
      {
        timeout: TWO_MINUTES,
      },
    )
    .then((response) => (response as any).duplicates);
};

export default getDocumentDuplicates;
